

import FilterIcon from '../../body/Icons/FilterIcon';
import SearchIcon from '../../body/Icons/SearchIcon';



export default function MenueBar({clickOnManueBarButton,isClosing,showModal,setOpenSearchToggle,openSearchToggle,setOpenFilterToggle}){
   
   

   function clickOnSearchToggle(e){
    setOpenFilterToggle(false)
     setOpenSearchToggle(true)
        clickOnManueBarButton(e)
    
          
        
            
   }

   function clickOnFilterToggle(e){
    setOpenSearchToggle(false)
        setOpenFilterToggle(prev=>!prev)    
        clickOnManueBarButton(e)
    
   }
   
 
  

    if (!isClosing){ return null}
    return(
        
        <>

            
            <div onClick={(e) => e.stopPropagation()}  className={`absolute right-0 top-[50px] z-50 bg-white rounded-xl shadow-lg min-w-[200px]  ${!showModal ? 'animate-closeSideBar' :'animate-openSideBar' } `}>
              <div  className="p-2">
             

            

                <button onClick={(e)=>clickOnFilterToggle(e)} className="flex w-full items-center space-x-3 rounded-lg px-3 py-2.5 text-left hover:bg-gray-50 transition-colors">
                  <i className="fa-solid fa-filter text-orange-500 w-3" >
                    <FilterIcon></FilterIcon>
                    </i>
                  <span className="text-sm">Filter</span>
                </button>

                <button onClick={(e)=>clickOnSearchToggle(e)}  className="flex w-full items-center space-x-3 rounded-lg px-3 py-2.5 text-left hover:bg-gray-50 transition-colors">
                  <i className="fa-solid fa-search text-purple-500 w-3" >
                    <SearchIcon></SearchIcon>
                  </i>
                  <span className="text-sm">Search</span>
                </button>
                
                <div className="relative" >

    
                </div>
              </div>
            </div>
      
          </>
    )
}